/* eslint-disable  */
import { Delete, Edit } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import PromptModal from "../../AdminModel/Components/PromptModal";
import CediSymbol from "../../Components/CediSymbol";
import RichTextBox from "../../Components/RichTextBox";
import { productActionCreators } from "../../services/Actions";
import ProductModal from "../Modal/AddProductModal";
import { UpdateProductBannerImage } from "../../services/Actions/productAction";
import Resizer from "react-image-file-resizer";
import { BsCreditCard2Front } from "react-icons/bs";
import { MdOutlineDeleteForever } from "react-icons/md";
import { FiEdit3, FiTrash2, FiEye, FiX, FiAlertCircle } from "react-icons/fi";

function ProductCard({ product, category }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { DeleteProduct, EditProduct, DeleteProductImages, GetSuppliers } =
    bindActionCreators(productActionCreators, dispatch);
  const [openEditProductModal, setOpenEditProductModal] = useState(false);
  const [openPromptModal, setPromptOpenModal] = useState(false);
  const [editProductFormData, setEditProductFormData] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);
  // Newly picked images awaiting upload — file + data-url kept together so
  // removing a preview thumbnail also drops it from what actually gets sent.
  const [newImages, setNewImages] = useState([]);
  // Cloud images removed locally so they disappear immediately instead of
  // waiting on a refetch (and never causing one, so the modal never reloads).
  const [removedImageKeys, setRemovedImageKeys] = useState([]);
  const [descriptionValue, setDescriptionValue] = useState("");
  const [previewBanner, setPreviewBanner] = useState(null);

  const [isFeaturedChecked, setIsFeaturedChecked] = useState(product?.featured);
  const [isBannerChecked, setBannerChecked] = useState(false);
  const [isBanner, setIsBanner] = useState(false);

  const { suppliers } = useSelector((state) => state.product);

  const cacheBuster = Math.random();

  const handleEditProductChnage = (e) => {
    const { name, value } = e.target;
    setEditProductFormData({ ...editProductFormData, [name]: value });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        setNewImages((prev) => [...prev, { file, url: event.target.result }]);
      };
      reader.readAsDataURL(file);
    });

    e.target.value = "";
  };

  const handleBannerFileChange = (e) => {
    const file = e.target.files[0];
    try {
      Resizer.imageFileResizer(
        e.target.files[0],
        800,
        500,
        "jpeg",
        100,
        0,
        (uri) => {
          dispatch(
            UpdateProductBannerImage(
              product._id,
              file,
              product?.banner_image_key ?? ""
            )
          );
        },
        "file",
        200,
        200
      );
    } catch (err) {
      console.log(err);
    }

    const reader = new FileReader();
    reader.onload = function (event) {
      setPreviewBanner(event.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleFeatureChecked = () => {
    setIsFeaturedChecked(!isFeaturedChecked);
  };

  const handleBannerChecked = () => {
    setBannerChecked(!isBannerChecked);
    setIsBanner(!isBanner);
    if (isBanner === false) {
      setPreviewBanner(null);
    }
  };

  const handleCheckColors = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      const filterColorExist = colors.find((color) => color === value);
      if (!filterColorExist) {
        setColors([...colors, value]);
      }
    } else {
      const filterColor = colors.filter((color) => color !== value);
      setColors(filterColor);
    }
  };

  const handleCheckSizes = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      const filterSizeExist = sizes.find((size) => size === value);
      if (!filterSizeExist) {
        setSizes([...sizes, value]);
      }
      setSizes([...sizes, value]);
    } else {
      const filter = sizes.filter((size) => size !== value);
      setSizes(filter);
    }
  };

  const handleDeleteCloudImage = (e, public_id, product_id) => {
    e.preventDefault();
    e.stopPropagation();
    // Hide it immediately — don't wait on the refetch to confirm.
    setRemovedImageKeys((prev) => [...prev, public_id]);
    DeleteProductImages(product_id, public_id);
  };

  const handleDeletePrevImage = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    setNewImages((prev) => prev.filter((img) => img !== item));
  };

  const handleEditProductSubmit = (e) => {
    e.preventDefault();
    const data = {
      ...editProductFormData,
      // The rich text box only reports a value once it is touched, so an
      // untouched edit used to overwrite the description with an empty string.
      description: descriptionValue || product?.description,
      colors: colors,
      sizes: sizes,
      banner: isBannerChecked,
      featured: isFeaturedChecked,
      // Keep whatever supplier was picked in the form; fall back to the current one.
      supplier: editProductFormData?.supplier || product?.supplier?._id,
    };
    EditProduct(product?._id, data, newImages.map((img) => img.file));
    setNewImages([]);
    setOpenEditProductModal(false);
  };

  useEffect(() => {
    setEditProductFormData({
      category: product?.category?._id,
      description: product?.description,
      featured: product?.featured,
      new_price: product?.new_price,
      old_price: product?.old_price,
      product_name: product?.product_name,
      // quantity intentionally omitted — stock is owned by the Inventory module.
      short_description: product?.short_description,
      banner: product?.banner,
    });
    setColors(product?.colors ?? []);
    setSizes(product?.sizes ?? []);
    GetSuppliers();
  }, []);

  useEffect(() => {
    // A background refetch (e.g. after the image delete below) swaps in a new
    // `product` object while the modal is open — don't clobber whatever the
    // admin is mid-editing when that happens.
    if (openEditProductModal) return;
    setIsFeaturedChecked(product?.featured);
    setBannerChecked(product?.banner);
    setColors(product?.colors ?? []);
    setSizes(product?.sizes ?? []);
    setEditProductFormData({
      category: product?.category?._id,
      description: product?.description,
      featured: product?.featured,
      new_price: product?.new_price,
      old_price: product?.old_price,
      product_name: product?.product_name,
      // quantity intentionally omitted — stock is owned by the Inventory module.
      short_description: product?.short_description,
      banner: product?.banner,
    });
  }, [product, openEditProductModal]);

  return (
    <>
      {/* Compact Product Card */}
      <div className="group bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100 dark:border-gray-700">
        {/* Image Container - Smaller */}
        <div className="relative h-36 bg-gray-50 dark:bg-gray-700 overflow-hidden">
          {product?.images?.length > 0 ? (
            <img
              src={product?.images[0]?.url + `?cb=${cacheBuster}`}
              alt="product"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <img
                src="/images/dev/product_placeholder.png"
                alt="product"
                className="w-16 h-16 object-contain opacity-50"
              />
            </div>
          )}

          {/* Stock Badge */}
          <div className={`absolute top-2 left-2 px-2 py-0.5 rounded-full text-xs font-medium ${product?.quantity > 0
            ? ' dark:text-green-700 text-green-700 bg-green-100'
            : 'bg-red-100 text-red-700'
            }`}>
            {product?.quantity > 0 ? "In Stock" : "Out of Stock"}
          </div>

          {/* Featured Badge */}
          {product?.featured && (
            <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
              Featured
            </div>
          )}
        </div>

        {/* Content - Compact */}
        <div className="p-3">
          {/* Product Name */}
          <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100 line-clamp-2 mb-1 leading-tight">
            {product?.product_name?.length > 50
              ? product?.product_name?.slice(0, 50) + "..."
              : product?.product_name}
          </h3>

          {/* Price */}
          <div className="flex items-center gap-2 mb-2">
            <span className="text-base font-bold text-emerald-600">
              <CediSymbol /> {product?.new_price}
            </span>
            {product?.old_price && (
              <span className="text-xs text-gray-400 line-through">
                <CediSymbol /> {product?.old_price}
              </span>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-1.5">
            <button
              onClick={() =>
                history.push({
                  pathname: "/inventory/product-detail",
                  state: { product_id: product?._id },
                })
              }
              className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-lg text-xs font-medium transition-colors"
            >
              <FiEye className="w-3.5 h-3.5" />
              View
            </button>

            <button
              onClick={() => {
                setNewImages([]);
                setRemovedImageKeys([]);
                setOpenEditProductModal(true);
              }}
              className="w-8 h-8 flex items-center justify-center dark:bg-gray-700 dark:hover:bg-green-800 hover:bg-blue-100 text-blue-600 rounded-lg transition-colors"
              title="Edit Product"
            >
              <FiEdit3 className="w-4 h-4" />
            </button>

            <button
              onClick={() => {
                setSelectedProduct(product);
                setPromptOpenModal(true);
              }}
              className="w-8 h-8 flex items-center justify-center dark:bg-gray-700 dark:hover:bg-red-700 hover:bg-red-100 text-red-600 rounded-lg transition-colors"
              title="Delete Product"
            >
              <FiTrash2 className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>

      {/* Edit Product Modal */}
      {openEditProductModal && (
        <ProductModal
          closeModal={setOpenEditProductModal}
          width="70%"
          title="Edit Product"
          height="90vh"
          overflowY="scroll"
        >
          <form className="space-y-6">
            {/* Product Name & Featured */}
            <div className="grid gap-6 md:grid-cols-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Product Name
                </label>
                <input
                  type="text"
                  id="product_name"
                  defaultValue={product?.product_name}
                  className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-800 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  name="product_name"
                  onChange={handleEditProductChnage}
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Featured Product
                  </label>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={isFeaturedChecked}
                      onChange={handleFeatureChecked}
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:ring-4 peer-focus:ring-blue-100 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    <span className="ml-3 text-sm text-gray-600">Featured</span>
                  </label>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Banner Product
                  </label>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={isBannerChecked}
                      onChange={handleBannerChecked}
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:ring-4 peer-focus:ring-blue-100 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    <span className="ml-3 text-sm text-gray-600">Banner</span>
                  </label>
                </div>
              </div>
            </div>

            {/* Banner Upload */}
            {isBanner && (
              <div className="p-4 bg-amber-50 border border-amber-200 rounded-xl">
                <label className="block text-sm font-medium text-amber-800 mb-2">
                  Upload Banner Image <span className="text-red-500">*</span>
                </label>
                <input
                  className="w-full text-sm text-gray-700 bg-white border border-amber-200 rounded-lg cursor-pointer file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-amber-100 file:text-amber-700 file:font-medium hover:file:bg-amber-200 transition-colors"
                  type="file"
                  onChange={handleBannerFileChange}
                />
                {previewBanner && (
                  <img
                    src={previewBanner}
                    alt="banner preview"
                    className="mt-3 h-20 rounded-lg object-cover"
                  />
                )}
              </div>
            )}

            {/* Short Description & Supplier */}
            <div className="grid gap-6 md:grid-cols-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Short Description
                </label>
                <input
                  type="text"
                  defaultValue={product?.short_description}
                  className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-800 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  name="short_description"
                  onChange={handleEditProductChnage}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Supplier
                </label>
                <select
                  onChange={handleEditProductChnage}
                  name="supplier"
                  className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-800 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                >
                  <option value={product?.supplier?._id}>
                    {product?.supplier?.name}
                  </option>
                  {suppliers?.map((supplier, index) => (
                    <option key={index} value={supplier?._id}>
                      {supplier?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Prices & Quantity */}
            <div className="grid gap-6 md:grid-cols-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  New Price
                </label>
                <input
                  type="text"
                  defaultValue={product?.new_price}
                  className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-800 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  name="new_price"
                  onChange={handleEditProductChnage}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Old Price
                </label>
                <input
                  type="text"
                  defaultValue={product?.old_price}
                  className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-800 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  name="old_price"
                  onChange={handleEditProductChnage}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Quantity
                </label>
                <input
                  type="number"
                  value={product?.quantity ?? 0}
                  readOnly
                  disabled
                  title="Stock is managed in the Inventory module"
                  className="w-full px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-xl text-gray-500 text-sm cursor-not-allowed"
                />
                <p className="mt-1.5 text-xs text-gray-400">
                  Stock is managed in <span className="font-semibold">Inventory &rsaquo; Adjust</span> so
                  every change is recorded.
                </p>
              </div>
            </div>

            {/* Colors, Sizes & Category */}
            <div className="grid gap-6 md:grid-cols-3">
              {/* Colors */}
              <div className="p-4 bg-gray-50 rounded-xl">
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Colors
                </label>
                <div className="flex flex-wrap gap-2 mb-3">
                  {product?.colors?.map((color, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 text-xs font-medium rounded-full"
                      style={{
                        backgroundColor: color,
                        color: color === "yellow" || color === "white" ? "#333" : "#fff",
                      }}
                    >
                      {color}
                    </span>
                  ))}
                </div>
                <div className="space-y-2">
                  {["black", "red", "blue", "yellow"].map((color) => (
                    <label key={color} className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        value={color}
                        onChange={handleCheckColors}
                        className="w-4 h-4 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-600 capitalize">{color}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Sizes */}
              <div className="p-4 bg-gray-50 rounded-xl">
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Sizes
                </label>
                <div className="flex flex-wrap gap-2 mb-3">
                  {product?.sizes?.map((size, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 bg-gray-800 text-white text-xs font-medium rounded-full"
                    >
                      {size}
                    </span>
                  ))}
                </div>
                <div className="space-y-2">
                  {["XL", "XLL", "S", "M"].map((size) => (
                    <label key={size} className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        value={size}
                        onChange={handleCheckSizes}
                        className="w-4 h-4 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-600">{size}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Category & Upload */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Category
                  </label>
                  <select
                    onChange={handleEditProductChnage}
                    name="category"
                    className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-800 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  >
                    <option value={product?.category?._id}>
                      {product?.category?.name}
                    </option>
                    {category?.map((cate, index) => (
                      <option key={index} value={cate?._id}>
                        {cate?.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Images
                  </label>
                  <label className="flex flex-col items-center justify-center w-full h-28 bg-gray-50 border-2 border-gray-200 border-dashed rounded-xl cursor-pointer hover:bg-gray-100 transition-colors">
                    <div className="flex flex-col items-center">
                      <svg className="w-8 h-8 text-gray-400 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                      </svg>
                      <p className="text-xs text-gray-500">Click to upload</p>
                    </div>
                    <input
                      onChange={handleFileChange}
                      type="file"
                      className="hidden"
                      multiple
                      accept="image/*"
                    />
                  </label>
                </div>
              </div>
            </div>

            {/* Image Previews */}
            {(product?.images?.filter((img) => !removedImageKeys.includes(img?.key)).length > 0 || newImages.length > 0) && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Product Images <span className="text-xs text-gray-400">(click × to remove)</span>
                </label>
                <div className="grid grid-cols-6 gap-2 p-3 bg-gray-50 rounded-xl">
                  {product?.images
                    ?.filter((img) => !removedImageKeys.includes(img?.key))
                    .map((img, index) => (
                      <div key={img?.key || index} className="relative">
                        <img
                          src={img?.url}
                          alt="preview"
                          className="w-full h-12 object-contain rounded-md"
                        />
                        <button
                          type="button"
                          onClick={(e) => handleDeleteCloudImage(e, img?.key, product?._id)}
                          className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center shadow"
                          aria-label="Remove image"
                        >
                          <FiX className="w-3 h-3" />
                        </button>
                      </div>
                    ))}
                  {newImages.map((item, index) => (
                    <div key={`new-${index}`} className="relative">
                      <img
                        src={item.url}
                        alt="preview"
                        className="w-full h-16 object-cover rounded-lg ring-2 ring-blue-400"
                      />
                      <button
                        type="button"
                        onClick={(e) => handleDeletePrevImage(e, item)}
                        className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center shadow"
                        aria-label="Remove image"
                      >
                        <FiX className="w-3 h-3" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Description */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Description
              </label>
              <RichTextBox
                setDescriptionValue={setDescriptionValue}
                defaultValue={product?.description}
              />
            </div>

            {/* Action Buttons */}
            <div className="flex items-center justify-end gap-3 pt-6 border-t border-gray-100">
              <button
                type="button"
                onClick={() => setOpenEditProductModal(false)}
                className="px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-xl transition-colors"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleEditProductSubmit}
                className="px-6 py-2.5 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white font-medium rounded-xl shadow-lg shadow-emerald-500/30 transition-all"
              >
                Save Changes
              </button>
            </div>
          </form>
        </ProductModal>
      )}

      {/* Delete Confirmation Modal */}
      {openPromptModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-[9999]">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
            {/* Header */}
            <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 dark:border-gray-700">
              <h3 className="text-lg font-bold text-gray-800 dark:text-gray-100">Delete Product</h3>
              <button
                onClick={() => setPromptOpenModal(false)}
                className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 transition-colors"
              >
                <FiX className="w-4 h-4" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
                <FiAlertCircle className="w-8 h-8 text-red-500" />
              </div>
              <h4 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
                Are you sure?
              </h4>
              <p className="text-gray-500 dark:text-gray-400 text-sm mb-6">
                This action cannot be undone. This will permanently delete the product
                <span className="font-medium text-gray-700 dark:text-gray-300"> "{product?.product_name?.slice(0, 30)}..."</span>
              </p>

              <div className="flex gap-3 justify-center">
                <button
                  onClick={() => setPromptOpenModal(false)}
                  className="px-6 py-2.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 font-medium rounded-xl transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    DeleteProduct(product?._id);
                    setPromptOpenModal(false);
                  }}
                  className="px-6 py-2.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-medium rounded-xl shadow-lg shadow-red-500/30 transition-all"
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ProductCard;